import axios from 'axios';
import { getAuth } from 'firebase/auth';

const API_BASE_URL = '/.netlify/functions';

async function getIdToken() {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) throw new Error('Użytkownik nie jest zalogowany');
  return user.getIdToken(true);
}

export const fetchSuggestions = async (
  category,
  platform,
  contentType,
  comment,
  commentType,
  themeType
) => {
  const idToken = await getIdToken();
  try {
    const response = await axios.post(
      `${API_BASE_URL}/fetch-advanced-suggestions`,
          { category, platform, contentType, comment, commentType, themeType },
      { headers: { Authorization: `Bearer ${idToken}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching advanced suggestions:', error.message);
    throw new Error(
      'Wystąpił błąd podczas generowania odpowiedzi. Spróbuj ponownie później.'
    );
  }
};

export const fetchSuggestionDetails = async (
  title,
  description,
  platform,
  contentType,
  commentType,
  themeType,
  category
) => {
  const idToken = await getIdToken();
  try {
    const response = await axios.post(
      `${API_BASE_URL}/fetch-advanced-details`,
      { title, description, platform, contentType, commentType, themeType, category },
      { headers: { Authorization: `Bearer ${idToken}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching advanced details:', error.message);
    throw new Error(
      'Wystąpił błąd podczas generowania szczegółów. Spróbuj ponownie później.'
    );
  }
};